<template>
    <v-dialog v-model="newJobModal" max-width="500">
        <v-card>
            <ModalHeader title="New Job Number" @close-clicked="closeModal" />

            <v-form validate-on="submit" @submit.prevent="submit">
                <v-card-text class="">
                    <v-row :dense="true">
                        <v-col>
                            <v-row :dense="true">
                                <v-col cols="auto" class="d-flex align-center justify-end">
                                    <div>New Job:</div>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        v-model="form.job_number"
                                        color="primary"
                                        variant="outlined"
                                        density="compact"
                                        hide-details
                                        required
                                        :error-messages="
                                            errors.jobNum
                                        "
                                        @input="updateJobNumber"
                                    ></v-text-field>
                                    <span class="error-message">{{ errors.jobNum }}</span>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn
                        color="primary"
                        variant="text"
                        type="submit"
                        :disabled="!form.job_number"
                    >
                        OK
                    </v-btn>
                    <v-btn
                        color="red"
                        variant="text"
                        @click="closeModal"
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import {defineAsyncComponent, ref} from "vue";
    import { useJobEntryStore } from "../../../../stores/ProjectManagement/JobEntry";
    import { mapWritableState } from "pinia";
    import ModalHeader from "../../../General/ModalComponents/ModalHeader.vue"

    export default {
        name: "NewJobModal",
        components: {
            ModalHeader
        },
        data() {
            return {
                form: {
                    job_number: null
                },
                errors: {
                    jobNum: ""
                }
            }
        },
        computed: {
            ...mapWritableState(useJobEntryStore, [
                "newJobModal",
                "newJobNumUpdated"
            ])
        },
        methods: {
            submit() {
                const regex = /^\d{2}-\d{3}\/[A-Z0-9]+$/;
                if (!regex.test(this.form.job_number)) {
                    this.errors.jobNum = 'Job Number is not in the correct format';
                } else {
                    this.newJobNumUpdated = this.form.job_number;
                }
            },
            closeModal() {
                this.form.job_number = null;
                this.newJobModal = false;
                this.errors.jobNum = null;
            },
            updateJobNumber(event) {
                // Get the current cursor position
                const cursorPosition = event.target.selectionStart;
                const inputElement = event.target;

                // Update the value to uppercase
                this.form.job_number = this.truncateJobNum(this.form.job_number).toUpperCase();

                // Restore the cursor position
                this.$nextTick(() => {
                    inputElement.setSelectionRange(cursorPosition, cursorPosition);
                });
            },
            truncateJobNum(str) {
                if (str.length > 15) {
                    this.errors.jobNum = 'Job Number can only be 15 characters long';
                    return str.slice(0, 15);
                } else {
                    return str;
                }
            },
        }
    }
</script>

<style scoped>
    .error-message {
        color: red;
    }
</style>
